<template>
  <div class="dialog animated fadeInUp" >
    <div class="topOne">
      <p>{{info.TITLE}}</p>
      <div class="closex wclosebtn" @click="$emit('close')">
            <span class="icon">
        <span class="circle"></span>
        <span class="line1"></span>
        <span class="line2"></span>
      </span>
      </div>
    </div>
    <div class="ttt" style="height: 500px;font-size: 12px;line-height: 30px;overflow: hidden"  data-scrollbar>
      <div style="width:100%;text-align: left;height:500px" v-html="info.CONTENT">
      </div>
    </div>
    <div class="f">
      <a class="ex-more" href="mailto:huaj@junanres.com" target="_blank">
        {{$t('human').text7}}
      </a>
      <router-link :to="{path: 'apply'}" target="_blank">
      <a class="ex-more" >
        {{$t('human').text8}}
      </a>
      </router-link>
    </div>
  </div>
</template>

<script>
  import Scrollbar from 'smooth-scrollbar';
  import {getNewsInfo} from '../util/lang'
    export default {
        name: "dialoga",
      data(){
          return{
            info:{
              title:'微组装'
            },
          }
      },
      props:['num'],
      mounted(){
        Scrollbar.initAll();
        this.getInfo(this.num)
      },
      methods:{
        getInfo(id){
          this.$nextTick(()=>{
            const url = `${getNewsInfo( 'zh-CN',id)}`
            this.$axios.get(url).then(res => {
              this.info=res.data
              console.log(res.data)
            })
          })
        },
      }
    }
</script>

<style lang="scss" scoped>
  .dialog{
    width:40%;
    background-color: white;
    margin: 0 auto;
    height:600px;
    padding:60px 50px;
    z-index: 1;
    .topOne{
      width:100%;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid rgba(0,0,0,.2);
      justify-content: space-between;
      padding-bottom: 10px;
      p{
        font-weight: bold;
        font-size: 20px;
      }
      .wclosebtn
      {
        cursor: pointer;
        z-index: 9;
        span{
          vertical-align: middle;
        }
        .icon{
          position: relative;
          width: 35px;
          height: 35px;
          margin-left: 12px;
          display: inline-block;
          .circle{
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border: 2px solid #000;
            -webkit-transition: all 300ms ease-out;
            transition: all 300ms ease-out;
            -webkit-transform-origin: center center;
            -ms-transform-origin: center center;
            transform-origin: center center;
          }
          .line1,.line2{
            position: absolute;
            top: 50%;
            left: 50%;
            display: block;
            width: 14px;
            height: 2px;
            margin: -1px 0 0 -7px;
            background-color: #000;
            -webkit-transition: all 300ms ease-out;
            transition: all 300ms ease-out;
          }
        }
        .icon:hover .circle{
          transform: scale(1.1);
        }
        .icon:hover .line1{
          transform: rotate(45deg);
        }
        .icon:hover .line2{
          -webkit-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          transform: rotate(-45deg);
          top: 16px;
        }
      }
    }
    .ev{
      text-align: left;
      width:80%;
      .t{
        font-weight: bold;
        font-size: 18px;
      }
      .c{
        font-size: 14px;
        line-height: 25px;
      }
    }
    .f{
      width:100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .ex-more{
        position: relative;
        display: block;
        width: 200px;
        height: 40px;
        font-size: 14px;
        font-weight: lighter;
        line-height: 40px;
        text-align: center;
        color: #fff;
        margin-top: 40px;
        background-color: #02509B;
        cursor: pointer;
        text-decoration: none;
        span{
          transition: all .6s;
        }
      }
    }
    @media screen and (max-width:450px){
      width:70%;
      height:600px;
      padding: 20px 30px;
      .ttt{
        height:390px !important;
      }
     .f{
       flex-direction: column;
       margin-top: 20px;
       align-items: center;
       .ex-more{
         margin-top: 20px;
       }
     }
    }
  }
</style>
